import { render, staticRenderFns } from "./HouseOwner.vue?vue&type=template&id=5b44c7bb&scoped=true&"
import script from "./HouseOwner.vue?vue&type=script&lang=js&"
export * from "./HouseOwner.vue?vue&type=script&lang=js&"
import style0 from "./HouseOwner.vue?vue&type=style&index=0&id=5b44c7bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44c7bb",
  null
  
)

export default component.exports